<template>
  <div id="pageTable">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <app-bar :title="`Nhập đại lý`"/>
        <v-flex xs12 sm12 md12 lg12 xl12>
          <v-card>
            <v-toolbar card color="white">
              <v-btn outline round color="primary" @click="pickFile" v-model="fileName">
                {{fileName}}
                <v-icon right>attach_file</v-icon>
              </v-btn>
              <input
                type="file"
                style="display: none"
                ref="fileUpload"
                accept=".xlsx, .xls, .csv"
                @change="onFilePicked"
              >
              <v-spacer></v-spacer>
              <v-btn
                flat
                round
                color="success"
                href="/static/Import_Account_Template.xlsx"
                target="_blank"
              >Tải file mẫu
                <v-icon right>cloud_download</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text class="pa-0">
              <import-account-table :isLoading="isLoading" :datasource="accountViewModels"/>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn flat @click="cancel()">Nhập lại</v-btn>
              <v-btn color="primary" @click="submit()" :loading="isImporting">Nhập đại lý</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import * as Utils from '@/utils';
import XLSX from 'xlsx';
import AppBar from '@/components/appbar';
import ImportAccountTable from './components/importlist';

export default {
  components: {
    ImportAccountTable,
    AppBar
  },
  data () {
    return {
      fileName: 'Chọn file',
      accountViewModels: [],
      isLoading: false,
      isImporting: false
    };
  },
  methods: {
    ...mapActions(['importDealer', 'getAccountById']),
    pickFile () {
      this.$refs.fileUpload.click();
    },
    onFilePicked (e) {
      const files = e.target.files;
      if (files[0] !== undefined) {
        this.parseExcelFileToJson(files[0]);
      }
    },
    parseExcelFileToJson (f) {
      this.isLoading = true;

      this.fileName = `Đã chọn: ${f.name}`;

      let reader = new FileReader();
      reader.readAsBinaryString(f);

      reader.onload = e => {
        let data = e.target.result;
        let workbook = XLSX.read(data, {
          type: 'binary'
        });
        let first_worksheet = workbook.Sheets[workbook.SheetNames[0]];
        let content = XLSX.utils.sheet_to_json(first_worksheet, {
          header: 1
        });

        this.accountViewModels = [];

        content.map((item, index) => {
          if (index > 0) {
            let account = {
              name: item[1],
              phone: item[2],
              email: item[3],
              password: '123456',
              address: item[4],
              isDistributor: false,
              isDealer: true,
              parentAccountName: item[5],
              parentAccountId: item[6],
              taxCode: item[7],
              remark: item[8]
            };
            if (account.name && account.phone && account.email) {
              this.accountViewModels.push(account);
            }
          }
          return 0;
        });
        this.isLoading = false;
      };
    },
    cancel () {
      window.location.reload();
    },
    submit () {
      if (this.accountViewModels.length === 0) {
        window.getApp.showMessage('Không có dữ liệu', 'error');
        return;
      }

      this.isImporting = true;
      this.importDealer(this.accountViewModels)
        .then(res => {
          this.isImporting = false;
          if (res.success === res.total) {
            window.getApp.showMessage(`Nhập thành công ${res.total} đại lý`);
            window.history.back();
          } else {
            if (res.success > 0) {
              window.getApp.showMessage(
                `Nhập thành công ${res.success} đại lý`
              );
            }
            if (res.fail > 0) {
              res.failList.map(account => {
                let accountImport = this.accountViewModels.find(
                  a => a.phone === account.phone
                );
                if (accountImport !== undefined) {
                  account.parentAccountName = accountImport.parentAccountName;
                }
                return 0;
              });
              this.accountViewModels = res.failList;
              window.getApp.showMessage(
                `Nhập thất bại ${res.fail} đại lý`,
                'error'
              );
            }
          }
        })
        .catch(_ => {
          this.isImporting = false;
          window.getApp.showMessage(
            'Nhập đại lý thất bại, vui lòng thử lại',
            'error'
          );
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/account/import.vue